import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {
    ISettingsMenuItem,
    SettingsPanel,
    SettingsRoutes
} from '@mintdata-wsp/wsp/ui/views/workspace/settings/SettingsPanel';
import {DataSource, IListItemState} from '@mintdata/mint-kit/api/models/List';
import {ContextMenu, IContextMenuItem, ToggleOn} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';
import {PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {IStyles} from '@mintdata/mint-kit/impl/util/Styles';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action, computed} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./SettingsMobileDropdown.less');
const cx = classnames.bind(styles);

interface IDesignFiltersDropdownProps
{
    selectedRoute:SettingsRoutes;
    onSelect:(subUrl:SettingsRoutes) => void;
}

interface IDesignFiltersDropdownState
{
    isOpened:boolean;
}

interface ISettingsMobileDropdownMenuItem extends IContextMenuItem
{
    subUrl:SettingsRoutes
}

@observer
export class SettingsMobileDropdown extends React.Component<IDesignFiltersDropdownProps, IDesignFiltersDropdownState>
{
    @computed
    private get _menuItems():Array<ISettingsMobileDropdownMenuItem>
    {
        const menuItems:Array<ISettingsMobileDropdownMenuItem> =
            SettingsPanel.SettingsMenuItems.map((item:ISettingsMenuItem, index:number) =>
            {
                return {
                    label: item.title,
                    subUrl: item.subUrl
                };
            });

        return menuItems;
    }

    public constructor(props:any)
    {
        super(props);

        this.state = {
            isOpened: false
        };
    }

    private _onShow = () => this.setState({isOpened: true});
    private _onHide = () =>
    {
        this.setState({isOpened: false});
    };

    @bind
    private _menuProvider():DataSource<ISettingsMobileDropdownMenuItem>
    {
        const {selectedRoute} = this.props;

        return this._menuItems.map((item:ISettingsMobileDropdownMenuItem) =>
        {
            const isSelected = item.subUrl === selectedRoute;

            return {
                ...item,
                isSelected,
                handler: () => this._selectMenuItem(item)
            } as ISettingsMobileDropdownMenuItem;
        });
    }

    @action
    private _selectMenuItem(item:ISettingsMobileDropdownMenuItem)
    {
        const {onSelect} = this.props;

        onSelect && onSelect(item.subUrl);
    }

    @bind
    private _renderSheetsMenuItem({label, isSeparator}:ISettingsMobileDropdownMenuItem,
                                  {isSelected}:IListItemState,
                                  {menuItem, separator}:IStyles):JSX.Element
    {
        if( isSeparator ) return (
            <div className={cx(separator)} />
        );

        return (
            <div className={cx(styles.menuItem, menuItem)}>

                <div className={styles.menuItemIcon}>
                    {
                        isSelected &&
                        <MDIcon
                            name={MDIcons.common.Checkmark}
                            size={MDIconSize.medium16}
                            className={styles.icon}
                        />
                    }
                </div>

                <div className={styles.menuItemLabel}>
                    {label}
                </div>

            </div>
        );
    }

    public render():JSX.Element
    {
        const togglerId = 'settingsMenuSelector';

        const {isOpened} = this.state;

        const {selectedRoute} = this.props;

        const selectedItem:ISettingsMenuItem =
            SettingsPanel.SettingsMenuItems.find(({subUrl}) => subUrl === selectedRoute);

        const selectedTitle = selectedItem ? selectedItem.title : '';

        return (
            <div className={cx(styles.base)} id={togglerId}>
                <ContextMenu
                    toggleOn={[ToggleOn.CLICK]}
                    togglersIds={[togglerId]}
                    popupAnchor={PopupAnchor.LeftTop}
                    sourceAnchor={SourceAnchor.LeftBottom}
                    popupClassName={styles.menuPopup}
                    dataSource={this._menuProvider}
                    itemRenderer={this._renderSheetsMenuItem}
                    onShow={this._onShow}
                    onHide={this._onHide}
                    contentClassName={styles.popupContent}
                >
                    <div className={cx(styles.handler, {isOpened})}>
                        {selectedTitle}
                        <MDIcon
                            className={cx(styles.menuIcon, {isOpened})}
                            name={MDIcons.common.ChevronRight}
                        />
                    </div>
                </ContextMenu>
            </div>
        );
    }
}
